@defer (on viewport; hydrate on immediate) {
	@for (blok of contentInputs(); track $index) {
		<div>
			@if (components) {
				<ndc-dynamic
					[ndcDynamicComponent]="components[blok['component']]"
					[ndcDynamicInputs]="blok"
				/>
			}
		</div>
	}
	<section
		[ngClass]="'gradient-160px' | sectionBgClass"
		class="section-spacing"
	>
		<div
			class="section-inner section-gap children:w-full children:md:mx-auto"
		>
			@if (roomsData$ | async; as roomsData) {
				@if (roomsData.length === 0) {
					<vp-alert
						[closeable]="false"
						[content]="'global.no-results-found' | translate"
						[type]="alertType"
					/>
				}
				@for (
					roomsWithCategory of roomsData;
					track roomsWithCategory.category
				) {
					@if (roomsWithCategory.rooms.length > 0) {
						<h3 class="running-head" data-test-class="running-head">
							{{ roomsWithCategory.category }}
						</h3>
						@for (
							room of roomsWithCategory.rooms;
							track room.guid
						) {
							<vp-persuade-card
								[cardUrl]="currentUrl + '/' + room.slug"
								[content]="room.summary"
								[ctaForceReload]="!bookingtool"
								[ctaUrl]="
									room.isBookable
										? room.bookingToolRedirectUrl
										: undefined
								"
								[ctaUrlQueryParams]="
									room.bookingToolQueryParams
								"
								[iconList]="room.iconList"
								[images]="room.images"
								[price]="
									room.isBookable ? room.price : undefined
								"
								[pricingToolTip]="{
									occupancy: room.pricingToolTip,
								}"
								[showReadMore]="true"
								[title]="room.title"
								imageVariant="mini-carousel"
							/>
						}
					}
				}
			}
		</div>
	</section>
} @placeholder {
	<vp-skeleton />
}
